<template>
  <MaintenanceState v-if="blockUserInMaintenance" />

  <LayoutStructure
    v-else-if="selectedOrganization"
    :menu="menu"
  >
    <template #app-sidebar-header>
      <component
        :is="overriddenTopbarComponent"
        v-if="hasOverriddenAppTopBar"
      />
      <OrganizationMenu v-else />
    </template>

    <template
      v-if="hasOverriddenAppSubMenu"
      #app-sidebar-body
    >
      <component :is="overriddenAppSubMenuComponent" />
    </template>

    <template #app-sidebar-footer>
      <component
        :is="bottomSlotComponent"
        v-if="hasBottomSlot"
      />
      <OrganizationMemberMenu />
      <div
        v-if="selectedOrganization?.isUnderMaintenance"
        class="mt-2 w-full cursor-pointer rounded-md bg-red-500"
        @click="navigateTo(AppRoutes.Admin.Organizations)"
      >
        <p class="text-center text-xs text-white">
          Organization is under maintenance
        </p>
      </div>
    </template>

    <slot />
  </LayoutStructure>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useOrganizationsStore } from '~/store/organizations'
import MaintenanceState from '~/components/layouts/default/states/MaintenanceState.vue'
import OrganizationMemberMenu from '~/components/layouts/default/OrganizationMemberMenu.vue'
import LayoutStructure from '~/components/layouts/common/LayoutStructure.vue'
import OrganizationMenu from '~/components/layouts/default/OrganizationMenu.vue'
import { SlotsComponents } from '~/constants/components/slots'
import { OverriddenComponents } from '~/constants/components/overrides'
import { AppRoutes } from '~/constants/routes'
import { AppRoles } from '~/constants/user'
import { isComponentOverridden } from '~/utils/components'

const menu = ref([])
onMounted(async () => {
  menu.value = getFormattedAppConfigMenuItems('app')
})

const organizationsStore = useOrganizationsStore()
const { selectedOrganization } = storeToRefs(organizationsStore)

const blockUserInMaintenance = computed(() =>
  selectedOrganization.value?.isUnderMaintenance
  && !isCurrentUserGrantedInApp(AppRoles.Admin),
)

watch(selectedOrganization, async (selectedOrganization: any) => {
  menu.value = selectedOrganization
    ? getFormattedAppConfigMenuItems('app')
    : []
})
const {
  isOverridden: hasOverriddenAppTopBar,
  overriddenComponent: overriddenTopbarComponent,
} = isComponentOverridden(OverriddenComponents.AppTopBar)
const {
  isOverridden: hasOverriddenAppSubMenu,
  overriddenComponent: overriddenAppSubMenuComponent,
} = isComponentOverridden(OverriddenComponents.AppSubMenu)
const {
  isOverridden: hasBottomSlot,
  overriddenComponent: bottomSlotComponent,
} = isComponentOverridden(SlotsComponents.AppSidebarBottom)
</script>
